import { defineStore } from "pinia";
import { computed, ref } from "vue";

export const useSubscriptionStore = defineStore("subscription", () => {
  const subscriptionActive = ref(false);

  function sync() {
    const store = window.klarnachrichten?.login?.app?.store;
    if (!store) return;

    const auth = store.getState().auth;
    if (!auth.user) return;

    let metadata = auth.user.metadata;
    if (typeof metadata === "string") {
      try { metadata = JSON.parse(metadata); } catch (e) { metadata = {}; }
    }
    subscriptionActive.value = !!metadata?.subscription;
  }

  const fronteggStore = window.klarnachrichten?.login?.app?.store;
  if (fronteggStore) {
    fronteggStore.subscribe(sync);
  }
  sync();

  const canSaveFilters = computed(() => subscriptionActive.value);
  const canUseDailySummary = computed(() => subscriptionActive.value);
  const canUseTTS = computed(() => subscriptionActive.value);
  const hasSubscription = computed(() => subscriptionActive.value);

  function openCheckout() {
    const paymentLink = window.klarnachrichtenConfig?.stripePaymentLink;
    if (paymentLink) {
      const store = window.klarnachrichten?.login?.app?.store;
      const email = store?.getState()?.auth?.user?.email;
      const userId = store?.getState()?.auth?.user?.id;
      const params = new URLSearchParams();
      if (email) params.set('prefilled_email', email);
      if (userId) params.set('client_reference_id', userId);
      const url = params.toString() ? `${paymentLink}?${params.toString()}` : paymentLink;
      window.location.href = url;
    }
  }

  return {
    subscriptionActive,
    canSaveFilters,
    canUseDailySummary,
    canUseTTS,
    hasSubscription,
    openCheckout,
  };
});
